

export const ACRONYMS_REQUEST =         "ACRONYMS_REQUEST";
export const ACRONYMS_REQUEST_SUCCESS = "ACRONYMS_SUCCESS";
export const ACRONYMS_REQUEST_FAIL =    "ACRONYMS_FAIL"
